import {Component, inject} from '@angular/core';
import {Notification, NotificationDetail, NotificationType} from '../notification.model'
import {NotificationService} from '../notification.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent {

  notifications: Array<Notification> = [];
  NotificationType = NotificationType;

  constructor(private notificationService: NotificationService) {
    this.notificationService.listen()
      .pipe(takeUntilDestroyed())
      .subscribe(newNotification => {
        if (newNotification.timeout) {
          setTimeout(() => this.closeNotification(newNotification), newNotification.timeout);
        }
        if (newNotification.uniqueToken) {
          this.notifications
            .filter(n => n.uniqueToken === newNotification.uniqueToken)
            .forEach(n => this.closeNotification(n));
        }
        this.notifications.push(newNotification);
      });
  }

  closeNotification(notificationToClose: Notification) {
    this.notifications = this.notifications
      .filter(notification => notification.uuid !== notificationToClose.uuid);
  }

  getTitle(type: NotificationType): string {
    switch (type) {
      case NotificationType.SUCCESS:
        return 'Action completed';
      case NotificationType.ERROR:
        return 'Action failed';
      case NotificationType.WARNING:
        return 'Warning';
      case NotificationType.INFO:
        return 'Information';
      default:
        return 'Notification';
    }
  }

  getIcon(type: NotificationType): string {
    switch (type) {
      case NotificationType.SUCCESS:
        return 'check_circle_outline';
      case NotificationType.ERROR:
        return 'highlight_off';
      case NotificationType.WARNING:
        return 'error_outline';
      case NotificationType.INFO:
        return 'info_outline';
      default:
        return 'notifications';
    }
  }
}
